import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { PlessJsonDownloadService } from 'src/app/shared/http/pless-json-download.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessDialogService } from '../../../shared/pless-dialog-service';

/**
 * ファイルをダウンロードするサービス
 *
 * @export FileDownloadService
 * @class FileDownloadService
 * @extends {PlessResponder}
 */
@Injectable()
export class FileDownloadService extends PlessJsonDownloadService {

  // 処理に使用するModel
  private filePath = String('');

  constructor(
    protected http: HttpClient,
    protected dialogService: PlessDialogService
  ) {
    super(http, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof FileDownloadService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        SpecifiedFile: this.filePath
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {string} filePath ファイルパス
   * @memberof FileDownloadService
   */
  execute(filePath: string, fileName: string) {
    this.filePath = filePath;
    this.send('KYMW02getSpecifiedFile', this.getBody(), String(fileName));
  }
}
